import { Component, OnInit, ViewChild } from '@angular/core';
import { TaskStatusComponent } from './task-status/task-status/task-status.component';
import { TaskStatus2Component } from './task-status/task-status2/task-status2.component';
import { TaskStatus3Component } from './task-status/task-status3/task-status3.component';
import { MatDialog } from '@angular/material/dialog'
import moment from 'moment';
import { DateFilterComponent } from './filter/date-filter/date-filter.component';
import { CategoriesService } from 'src/app/service/categories.service';
import { OperatingproceduresService } from 'src/app/service/operatingprocedures.service';
import { TaskService } from 'src/app/service/task.service';
import { UsersService } from 'src/app/service/users.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LateConfComponent } from './dialog/late-conf/late-conf.component';
import { PeriodsService } from 'src/app/service/periods.service';
import { BoardsService } from 'src/app/service/boards.service';
import { TemplatesService } from 'src/app/service/templates.service';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { StatusComponent } from './dialog/status/status.component';
import { ExcelService } from 'src/app/service/excel.service';
// ESM
import { Router } from '@angular/router';
import { DeleteBoardTaskDialogComponent } from 'src/app/core/dialogs/delete-board-task-dialog/delete-board-task-dialog.component';
import { Module, GridOptions, FilterChangedEvent } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { Injectable, Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag'; // NOSONAR
import { BehaviorSubject, Observable } from 'rxjs';
import { FGA_API_ENDPOINT } from '../../app.module';
import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { GET_FGA_AM_USER_DATA, GET_FGA_USER_DATA } from 'src/app/constants';
import { DateFloatingFilterComponent } from './filter/date-filter/date-floating-filter.component';
export interface DialogData {
	board_task_id,
	region,
	task,
	due,
	userid,
	params
}
@Component({
	selector: 'app-board',
	templateUrl: './board.component.html',
	styleUrls: ['./board.component.scss'],
	standalone: false,  // NOSONAR
})
export class BoardComponent implements OnInit {
	private readonly apollo: ApolloClient<NormalizedCacheObject>;
	gridApi: any;
	gridColumnApi: any
	defaultColDef = {
		resizable: true,
		floatingFilter: true
	};
	setPagination = true;
	paginationPageSize = 30;
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	closeResult = '';
	rowCount;
	boardData;
	temp5;
	selected_board;
	rowData;
	temp6;
	teamData;
	public modules: Module[] = [];
	@ViewChild('agGrid', { static: true }) agGrid: AgGridAngular
	// for export
	@ViewChild('agGrid') boardGrid;
	gridOptions: GridOptions;
	@ViewChild('picker') picker;
	secondHalf;
	firstHalf;
	columnDefs;
	columnRegions;
	tempColumnDefs;
	regionsArray;
	tempData;
	tempData2;
	selected_team;
	public getRowHeight: any;
	userID;
	usertemp: string;
	userInfo: any;
	activate_completed;
	activate_myTask;
	enableCompleted: number;
	errorMessage: string;
	successMessage: string;
	context: any;
	dynamicHeight;
	currentPage;
	region = 'region-data'
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 30;
	endRecord = 0;
	pgDropDown = [
		{ value: 5, selected: false },
		{ value: 10, selected: false },
		{ value: 20, selected: false },
		{ value: 30, selected: true },
		{ value: 50, selected: false },
	]
	dueDateValueFormatter(params) {
		let displayValue;
		if (params.data.DUE == 'null') { // NOSONAR
			displayValue = '';
		}
		else {
			const temp = params.data.DUE.split(" ");
			const dispArr = temp[0].split("-");
			displayValue = dispArr[1] + "." + dispArr[2];
		}
		return displayValue;
	}
	periodNameValueFormatter(params) {
		let displayValue;
		if (params.data.PERIOD_NAME == 'null') { // NOSONAR
			displayValue = '';
		}
		else {
			displayValue = params.data.PERIOD_NAME.split('|')[0];
		}
		return displayValue;
	}
	ddayValueFormatter(params) {
		let displayValue;
		if (params.data.DDAY == 'null' || params.data.DDAY == 'D') { // NOSONAR
			displayValue = '';
		}
		else {
			displayValue = params.data.DDAY;
		}
		return displayValue;
	}
	weekdayValueFormatter(params) {
		let displayValue;
		if (params.data.WEEKDAY == 'null') { // NOSONAR
			displayValue = '';
		}
		return displayValue;
	}
	contdateValueFormatter(params) {
		let displayValue;
		if (params.data.CONTINGENCY_DATE == 'null') { // NOSONAR
			displayValue = '';
		}
		return displayValue;
	}
	taskValueFormatter(params) {
		let displayValue;
		if (params.data.TASK == 'null') {  // NOSONAR
			displayValue = '';
		}
		return displayValue;
	}
	duetimeValueFormatter(params) {
		let displayValue;
		if (params.data.DUE_TIME == 'null') { // NOSONAR
			displayValue = '';
		}
		return displayValue;
	}
	sizeToFit() { this.gridApi.sizeColumnsToFit(); }
	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }
	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }
	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }
	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }
	onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); this.updatePaginationDetails(); }
	goToPageNumber(pageNumber) {
		if (pageNumber) {
			this.gridApi.paginationProxy.currentPage = pageNumber;
		}
	}
	getCurrentPage(): boolean {
		this.currentPageNo = this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0;
		if (this.currentPageNo == 0) { // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}
	isLastPage(): boolean {
		this.totalPage = Number(this.agGrid.api?.paginationGetTotalPages());
		this.currentPageForTotalPage = Number(this.agGrid.api?.paginationGetCurrentPage()) + 1;
		if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}
	rppChanged(event: any) {
		this.cPage = 1;
		this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}
	updatePaginationDetails() {
		if (this.gridApi) {
		this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
		this.tPage = this.gridApi.paginationGetTotalPages();
		this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
		this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
		this.totalRecords = this.gridApi.paginationGetRowCount();
		this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}
	onGridReady(param: any) {
		this.gridApi = param.api;
		this.gridColumnApi = param.columnapi;
	}
	onGridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
	}
	$timeout() {
		this.gridApi.core.handleWindowResize();
	};
	MACOpenStatusChangeDialog(params) {
		console.info("MACOpenStatusChangeDialog", params);
		this.currentPage = this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0;
		const dialogRef = this.dialog.open(StatusComponent, {
			disableClose: true,
			width: '250px',
			height: '120px',
			data: {
				params: params, page: 'task-status-2'
			}
		});
		dialogRef.afterClosed().subscribe(_result => {
			this.loadData();
		});
	}
	MACPastStatusChangeDialog(params) {
		console.info("MACPastStatusChangeDialog", params);
		this.currentPage = this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0;
		// slice(-1,1) to remove the single quotes from region
		const dialogRef = this.dialog.open(LateConfComponent, {
			disableClose: true,
			width: '503px',
			panelClass: 'custom-dialog-panel',
			data: {
				//board_task_id: params.data.BOARD_TASK_ID, region: params.colDef.field.slice(1, -1),
				board_task_id: params.data.BOARD_TASK_ID, region: params.colDef.field,
				task: params.data.TASK, due: params.data.DUE, userid: this.userID, params: params
			}
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result.event != "cancel") { // NOSONAR
				this.loadData();
			}
		});
	}
	MAIStatusChangeDialog(params) {
		console.info("MAIStatusChangeDialog", params);
		this.currentPage = this.agGrid.api ? this.agGrid.api.paginationGetCurrentPage() : 0;
		const dialogRef = this.dialog.open(StatusComponent, {
			disableClose: true,
			width: '250px',
			height: '120px',
			data: {
				params: params, page: 'task-status'
			}
		});
		dialogRef.afterClosed().subscribe(_result => {
			this.loadData();
		});
	}
	// integrating board get tasks api
	loadData() {
		this.context = {
			componentParent: this
		};
		this.ngxUiLoaderService.start("loader-01");
		const userData = sessionStorage?.getItem('FGA');
		if (userData) {
			this.userID = JSON.parse(userData)?.user?.userPrincipalName;
		}
		if (this.activate_completed) {
			this.enableCompleted = 1;
		}
		else if (!this.activate_completed) {
			this.enableCompleted = 0;
		}
		// 	API Integration
		this.rowData = [];
		this.tempData = [];
		this.tempData2 = [];
		this.regionsArray = [];
		this.tempColumnDefs = [];
		this.columnDefs = [];
		this.boardService.getDetails(this.userID, this.selected_board, this.selected_team, this.enableCompleted).subscribe(result => {
			console.info("calling getdetails")
			if (result && result.length > 0) {
				this.tempData = result;
				const regionsArray = [];
				let tempArr = [];
				const e = this.tempData[0];
				let ct = 0;
				tempArr = Object.keys(e);
				tempArr.forEach(function (key) {
					let object;
					if (ct >= 14) {
						let regionDesc;
						const temp3 = localStorage.getItem('region-data');
						const regionList = JSON.parse(temp3);
						if (key == "USER") { // NOSONAR
							regionDesc = "USER";
						}
						else {
							regionList?.filter(x => x.region_code == key).forEach(element => { // NOSONAR
								regionDesc = element.region;
							});
						}
						object = { "key": key, "value": e[key], "label": regionDesc };
						regionsArray.push(object);
					}
					ct++;
				})
				this.regionsArray = regionsArray;
				this.firstHalf = [
					{
						headerName: 'DUE', field: 'DUE', headerClass: 'header_due', cellClass: 'cell_due', minWidth: 40, width: 40,
						suppressMovable: true, resizable: false, filter: true,
						filterFramework: DateFilterComponent,
						floatingFilter: true, floatingFilterComponentParams: { suppressFilterButton: true },
						floatingFilterComponent: DateFloatingFilterComponent,
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
						suppressMenu: true,
						valueFormatter: this.dueDateValueFormatter,
						filterParams: {
							filterOptions: ['inRange'],
							defaultOption: 'inRange',
							maxNumConditions: 1,
							suppressAndOrCondition: true,
							inRangeInclusive: true,
						},
						comparator: (filterLocalDateAtMidnight, cellValue) => {
								const dateAsString = moment(cellValue).format('DD/MM/YYYY');
								const dateParts = dateAsString.split("/");
								const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
								if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) { // NOSONAR
									return 0
								}
								if (cellDate < filterLocalDateAtMidnight) {
									return -1;
								}
								if (cellDate > filterLocalDateAtMidnight) {
									return 1;
								}
								else {
									return 0;
								}
							}
						},
					{
						headerName: "PERIOD", field: "PERIOD_NAME", headerClass: "header_period", cellClass: "cell_period",
						minWidth: 40, width: 40, suppressMovable: true,
						suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
						filter: 'agTextColumnFilter',
						valueFormatter: this.periodNameValueFormatter,
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
					},
					{
						headerName: "D-DAY", field: "DDAY", headerClass: "header_dDay", cellClass: "cell_dDay", minWidth: 37,
						width: 37, valueFormatter: this.ddayValueFormatter, suppressMovable: true,
						suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
						filter: 'agTextColumnFilter',
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
					},
					{
						headerName: "DAY", field: "WEEKDAY", headerClass: "header_day", cellClass: "cell_day",
						width: 20, minWidth: 20, valueFormatter: this.weekdayValueFormatter, suppressMovable: true,
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
					},
					{
						headerName: "CONT", field: "CONTINGENCY_DATE", headerClass: "header_cont", cellClass: "cell_cont",
						minWidth: 40, width: 40, suppressMovable: true,
						suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
						valueFormatter: this.contdateValueFormatter,
						filter: 'agTextColumnFilter',
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
					},
					{
						headerName: "TASK", field: "TASK", headerClass: "header_task", cellClass: "cell_task_left", width: 235,
						autoHeight: true, minWidth: 235, wrapText: true, suppressMovable: true,
						suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true,
						valueFormatter: this.taskValueFormatter,
						filter: 'agTextColumnFilter',
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
					},
					{
						headerName: "OP", field: "OPERATING_PROCEDURE_URL", headerClass: "header_op", cellClass: "cell_op",
						minWidth: 20, width: 20, suppressMovable: true,
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						}, cellRendererSelector: (params) => {
							const taskStatus = {
								component: 'taskStatusCellRenderer',
								// params: {
								// 	values: ['fileAvailable'],
								// },
							};
							if (params.data.OPERATING_PROCEDURE_URL) { return taskStatus; }
							else { return null; }
						},
					}];
				//regions
				this.columnRegions = [];
				this.regionsArray.forEach(e => {
					const region = e.key;
					let region_headerName;
					region_headerName = String(e.label);
					const numericNo = parseInt(region_headerName.slice(0, 2));
					// region header format -> 1. stripping "TMM", 2. "50SER"=>"SER"
					if (region_headerName.slice(0, 3) == "TMM") { // NOSONAR
						region_headerName = region_headerName.slice(3);
					}
					if (!isNaN(numericNo)) {
						region_headerName = region_headerName.slice(2);
					}
					const obj = {
						headerName: region_headerName, field: region, headerClass: "header_" + region,
						cellClass: "cell_" + region, width: 35, minWidth: 35, suppressMovable: true,
						resizable: false,
						cellRendererSelector: (params) => {
							const value = params.value;
							let status;
							if (value == 'null') { // NOSONAR
								status = null;
							}
							else {
								const regionData = value.split("|");
								status = regionData[0];
							}
							const taskStatus3 = {
								component: 'taskStatus3CellRenderer',
							};
							const taskStatus = {
								component: 'taskStatusCellRenderer',
							};
							const taskStatus2 = {
								component: 'taskStatus2CellRenderer',
							};
							// check for proper condition, past due or white one and assign value to status..
							if (status == null) { // NOSONAR
								return taskStatus3;
							} else if (status == "C" || status == "F" || status == "L") { // NOSONAR
								return taskStatus;
							} else if (status == "O") { // NOSONAR
								return taskStatus2;
							} else {
								return null;
							}
						}
					}
					this.columnRegions.push(obj);
				});
				this.secondHalf = [
					{
						headerName: "TIME", field: "DUE_TIME", headerClass: "header_time", cellClass: "cell_time",
						minWidth: 35, width: 35, valueFormatter: this.duetimeValueFormatter, suppressMovable: true,
						cellStyle: function (params) {
							let bgclr;
							const currentdate = new Date();
							const dueDate = new Date(params.data.DUE);
							if (dueDate.toDateString() == currentdate.toDateString()) { // NOSONAR
								bgclr = '#ffff00';
							}
							else {
								bgclr = params.data.BACKGROUND_COLOR;
							}
							if (bgclr && params.data.FONT_COLOR) {
								return { 'background-color': bgclr, 'color': params.data.FONT_COLOR, 'height': '100%' }
							} else {
								return null;
							}
						},
					},
					{
						headerName: "ACTIONS", field: "board_editdelete", headerClass: "board_headerClass", cellClass: "cell_action",
						minWidth: 55, width: 55, suppressMovable: true,
						cellRenderer: BtnCellRenderer,
						cellRendererParams: {
							clicked: function (_field: any, _act: any) {
								// do something
							}
						}
					},
				];
				this.tempColumnDefs = this.firstHalf.concat(this.columnRegions);
				this.columnDefs = this.tempColumnDefs.concat(this.secondHalf);
				this.rowData = this.tempData;
				if (this.rowData.length) {
					this.totalRecords = this.rowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
				this.gridApi.applyTransaction({ add: this.rowData });
				this.rowCount = this.rowData.length;
				this.goToPageNumber(this.currentPage);
				this.ngxUiLoaderService.stop("loader-01");
			}
			else {
				this.rowCount = 0;
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			this.ngxUiLoaderService.stop("loader-01");
		});
	}
	// delete
	deleteBoardRow(params) {
		const boardTaskID = params.data.BOARD_TASK_ID;
		const dialogRef = this.dialog.open(DeleteBoardTaskDialogComponent, {
			disableClose: true,
			width: '401px',
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result.action == 'confirm') { // NOSONAR
				console.info("confirm");
				this.deleteBoardTaskRow(boardTaskID);
			}
		});
	}
	deleteBoardTaskRow(boardTaskID) {
		this.ngxUiLoaderService.start("loader-01");
		this.boardService.deleteBoardTask(boardTaskID).subscribe(_result => {
			this.successMessage = 'Deleted Row(s) Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			//fetch latest row data after deleting
			this.loadData();
		});
	}
	editBoardRow(params) {
		// redirect to period page
		console.info("params for edit in board", params);
		const tempData = {
			"params": params.data
		}
		if (params.data.PERIOD_NAME.split('|')[0].trim() != '') { // NOSONAR
			this.router.navigateByUrl('/editperiod', { state: tempData });
		}
		else {
			this.router.navigateByUrl('/editonetime', { state: tempData });
		}
	}
	constructor(public dialog: MatDialog, private readonly categoriesService: CategoriesService,
		private readonly OPService: OperatingproceduresService, private readonly taskService: TaskService,
		private readonly userService: UsersService, private readonly ngxUiLoaderService: NgxUiLoaderService,
		private readonly periodService: PeriodsService, private readonly boardService: BoardsService,
		private readonly templatesService: TemplatesService, private readonly excelService: ExcelService,
		private readonly router: Router, @Inject(FGA_API_ENDPOINT) private readonly endpoint: string) {
		this.dynamicHeight = 0.665 * (window.innerHeight);
		this.gridOptions = {
			theme: 'legacy',
			components: {
				taskStatusCellRenderer: TaskStatusComponent,
				taskStatus2CellRenderer: TaskStatus2Component,
				taskStatus3CellRenderer: TaskStatus3Component,
				// checkfilter: LateConfComponent,
				dateFilter: DateFilterComponent,
				btnCellRenderer: BtnCellRenderer
			}
		};
		// Create the HTTP Link
		const httpLink = createHttpLink({ uri: endpoint });
		// Create the Authorization Link
		const authLink = setContext((_, { headers }) => {
			const token = sessionStorage.getItem('accessToken'); // Retrieve the access token
			return {
				headers: {
					...headers,
					Authorization: token ? `Bearer ${token}` : '',
				},
			};
		});
		// Combine Links
		const link = ApolloLink.from([authLink, httpLink]) as any;
		// Initialize Apollo Client
		this.apollo = new ApolloClient({
			link,
			cache: new InMemoryCache(),
		});
	}
	ngOnInit(): void {
		this.selected_board = "0";
		this.selected_team = "0";
		this.ngxUiLoaderService.start("loader-01");
		// fethcing all backend data and storing in local storage
		// categories
		this.getUserData()
		this.categoriesService.getDetails().subscribe(result => {
			console.info("calling categories getdetails")
			if (result && result.length > 0) {
				//storing categories data in local
				localStorage.setItem('categories-data', JSON.stringify(result));
			}
			else {
				localStorage.setItem('categories-data', '[{}]');
			}
			// OP
			this.OPService.getDetails().subscribe(result => {
				console.info("calling OP getdetails")
				if (result && result.length > 0) {
					//storing OP data in local
					localStorage.setItem('OP-data', JSON.stringify(result));
				}
				else {
					localStorage.setItem('OP-data', '[{}]');
				}
				// task
				this.taskService.getDetails().subscribe(result => {
					console.info("calling task getdetails")
					if (result && result.length > 0) {
						//storing task data in local
						localStorage.setItem('task-data', JSON.stringify(result));
					}
					else {
						localStorage.setItem('task-data', '[{}]');
					}
					// regions
					this.userService.getRegionDetails().subscribe(result => {
						console.info("calling region getdetails")
						if (result && result.length > 0) {
							//storing task data in local
							localStorage.setItem(this.region, JSON.stringify(result));
						}
						else {
							localStorage.setItem(this.region, '[{}]');
						}
						// periods
						this.periodService.getPeriodList().subscribe(result => {
							console.info("calling periods getdetails")
							if (result && result.length > 0) {
								//storing task data in local
								localStorage.setItem('period-data', JSON.stringify(result));
							}
							else {
								localStorage.setItem('period-data', '[{}]');
							}
							// boards
							this.boardService.getBoardList().subscribe(result => {
								console.info("calling boards getdetails")
								const board_data = 'board-data'
								if (result && result.length > 0) {
									//storing task data in local
									localStorage.setItem(board_data, JSON.stringify(result));
								}
								else {
									localStorage.setItem(board_data, '[{}]');
								}
								// templates
								this.templatesService.getTemplateDetails().subscribe(result => {
									console.info("calling templates getdetails")
									if (result && result.length > 0) {
										//storing task data in local
										localStorage.setItem('template-data', JSON.stringify(result));
									}
									else {
										localStorage.setItem('template-data', '[{}]');
									}
									// team - data
									this.boardService.getTeamsList().subscribe(result => {
										console.info("calling team data getdetails")
										const team_list = 'teams-List'
										if (result && result.length > 0) {
											//storing task data in local
											localStorage.setItem(team_list, JSON.stringify(result));
										}
										else {
											localStorage.setItem(team_list, '[{}]');
										}
										this.temp5 = localStorage.getItem(board_data);
										this.boardData = JSON.parse(this.temp5);
										this.temp6 = localStorage.getItem(team_list);
										this.teamData = JSON.parse(this.temp6);
										console.info("I am in oninit");
										this.loadData();
									});
								});
							});
						});
					});
					// });
				});
			});
		});
		// }
		// else {
		//board page dropdowns
		this.getRowHeight = function (params) {
			return 24 * (params.data.TASK.length / 100 + 1);
		}
	}
	async getUserData() {
		try {
			const result = await this.apollo.query<any>({
				query: GET_FGA_AM_USER_DATA,
				fetchPolicy: 'no-cache',
				errorPolicy: 'all',
				"variables": {
					"firstName": "",
					"lastName": "",
					"middleName": null,
					"userPrincipalName": "",
					"email": "",
					"roles": [
						"Task Manager Admin",
						"Task Manager User"
					]
				}
			});
			const data = result?.data?.listUsersByFilters;
			console.info('FGA DATADDDDD:', data);
			if (data && data.length > 0) {
				//storing task data in local
				localStorage.setItem('users-data', JSON.stringify(data));
			}
			else {
				localStorage.setItem('users-data', '[{}]');
			}
			return true
		} catch (err) {
			console.info('GraphQL query error:', err);
			return false; // ✅ Handle failure gracefully
		}
	}
	onBoardChange() {
		this.loadData();
		console.info("completed toggle", this.activate_completed);
	}
	onTeamChange() {
		this.loadData();
	}
	onCompletedToggle() {
		this.loadData();
	}
	onMyTaskToggle() {
		// activate my tasks
		const tempData = {
			"data": "data"
		}
		this.router.navigateByUrl('/mytasks', { state: tempData });
	}
	refresh() {
		this.loadData();
	}
	/*Exports all data in XLSX format */
	onBtExport() {
		if (this.rowData.length > 0) {
			const exportData = [];
			this.gridApi.forEachNodeAfterFilter(function (rowNode, _index) {
				const e = rowNode.data;
				let year;
				let due_date;
				let due_time;
				if (e.DUE == "null") { // NOSONAR
					due_date = '';
					due_time = '';
				}
				else {
					const temp1 = e.DUE.split(" ")[0];
					const temp2 = temp1.split("-");
					due_date = temp2[1] + "/" + temp2[2] + "/" + temp2[0];
					due_time = e.DUE.split(" ")[1].slice(0, 5);
				}
				const regionsArray = [];
				let ct = 0;
				let userValue;
				Object.keys(e).forEach(function (key) {
					if (key == "USER") { // NOSONAR
						userValue = e[key]?.split("|")[1];
					}
					// if index of key after 13, it is region
					if (ct >= 14) {
						if (e[key] != "null" && key != "USER") { // NOSONAR
							regionsArray.push(key);
						}
					}
					ct++;
				})
				const regions = regionsArray.join();
				let dday;
				if (e.DDAY == "null") { // NOSONAR
					dday = '';
				}
				else {
					dday = e.DDAY;
				}
				let period;
				if (e.PERIOD_NAME == "null") { // NOSONAR
					period = '';
					year = '';
				}
				else {
					period = e.PERIOD_NAME.split('|')[0].trim();
					year = e.PERIOD_NAME.split('|')[1].trim();
				}
				let contDate;
				if (e.CONTINGENCY_DATE == "null") { // NOSONAR
					contDate = '';
				}
				else {
					contDate = e.CONTINGENCY_DATE;
				}
				let weekday;
				if (e.WEEKDAY == "null") { // NOSONAR
					weekday = '';
				}
				else {
					weekday = e.WEEKDAY;
				}
				let task;
				if (e.TASK == "null") { // NOSONAR
					task = '';
				}
				else {
					task = e.TASK;
				}
				const obj = {
					board_task_id: e.BOARD_TASK_ID,
					period: period,
					year: year,
					dday: dday,
					cont_date: contDate,
					day: weekday,
					due_date: due_date,
					due_time: due_time,
					task: task,
					primary_user: userValue,
					secondary_user: userValue,
					regions: regions
				};
				exportData.push(obj);
			});
			const headers = ['ID', 'Period', 'Year', 'DDay', 'Contingency Date', 'Day', 'Due Date',
				'Due Time', 'Task', 'Primary User', 'Secondary User', 'Regions'];
			this.excelService.exportAsExcelFile(exportData, 'Export', headers);
		}
	}
	onFilterChanged(params: FilterChangedEvent) {
		this.rowCount = params.api.getDisplayedRowCount();
	}
	updateCalendar() {
		this.ngxUiLoaderService.start("loader-01");
		this.boardService.updateCal().subscribe(result => {
			console.info("result", result);
			if (result == "Update Calendar Successfully") { // NOSONAR
				this.ngxUiLoaderService.stop("loader-01");
				this.successMessage = 'Updated Calendar Successfully!';
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
			else {
				this.ngxUiLoaderService.stop("loader-01");
				this.errorMessage = 'Updated Calendar Failed! Please Try again later.';
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
		});
	}
}
